import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Existing pages
import HomePage from './pages/HomePage';
import AboutUsFullPage from './pages/AboutUsFullPage';
import OurTeamPage from './pages/OurTeamPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';

// New pages
import MembershipPage from './pages/MembershipPage';
import MembershipLookupPage from './pages/MembershipLookupPage';
import GalleryPage from './pages/GalleryPage';
import FAQPage from './pages/FAQPage';
import CommitteePage from './pages/CommitteePage';
import CricketClubPage from './pages/CricketClubPage';
import FeedbackPage from './pages/FeedbackPage';

// Admin
import AdminApp from './admin/AdminApp';

import { checkAndClearCache } from './utils/cacheBuster';
import './styles/theme.css';
import './App.css';

function App() {
  useEffect(() => {
    checkAndClearCache();
  }, []);

  return (
    <Router>
      <Routes>
        {/* Admin panel */}
        <Route path="/admin/*" element={<AdminApp />} />

        {/* Public pages */}
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutUsFullPage />} />
        <Route path="/team" element={<OurTeamPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:id" element={<EventDetailPage />} />
        <Route path="/membership" element={<MembershipPage />} />
        <Route path="/membership-lookup" element={<MembershipLookupPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/committee" element={<CommitteePage />} />
        <Route path="/cricket-club" element={<CricketClubPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
      </Routes>
    </Router>
  );
}

export default App;
